<header class="header">
  <div class="header-content">

    <!-- Botão à esquerda -->
    <button
      mat-icon-button
      class="menu-toggle"
      (click)="toggleExpansion()"
      aria-label="Toggle menu">
      <mat-icon>menu</mat-icon>
    </button>

    <!-- Espaço expansível que empurra os itens à direita -->
    <div class="spacer"></div>

    <!-- Logo e logout à direita -->
    <div class="right-section">
      <div class="logo-container">
        <img
          src="../assets/images/VIRESCO.png"
          alt="Viresco ERP Educacional"
          class="logo"
          [routerLink]="['dashboard']"
          [relativeTo]="route"
        />
      </div>

      <button
        mat-icon-button
        class="logout-btn"
        (click)="onLogout()"
        aria-label="Logout">
        <mat-icon>logout</mat-icon>
      </button>
    </div>

  </div>
</header>
